export const LOCATION_NOTES = {
    OTHER_LOCATION: 'checkpointInspectionGPSOtherLocation',
    CORRECT: 'checkpointInspectionGPSCorrect',
    WITHOUT_LOCATION: 'checkpointInspectionWithoutGPS',
    EXPIRED: 'inspectionHasNotBeenDone'
};
